// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Cookies from 'universal-cookie';
import {
    getUserPrefs,
    manageUserPref,
    logoutWfsSeller,
    clearStorage,
    getUserMetaData,
    createAxiosInstance,
} from './services';
import _ from 'lodash';
import { setupCache } from 'axios-cache-adapter';
import merge from 'deepmerge';
import GscopeMfeTools from './tools';
import { IS_TEST_ENV, SESSION_STORAGE_GSCOPE_MODULE_LIST_KEY } from './constants';
import axiosLib from 'axios';

const cache = setupCache();
const MFE_TEMP_BUCKET_NAME = 'MFE TEMP BUCKET';
const APPNAME_REG_PATTERN = /[^a-zA-Z0-9 ]/g;
const cookies = new Cookies();
let savePreference;
let userPrefData;
const POLICY_NAME_REGEX = /[\.\:]/;
const axios = createAxiosInstance();

const MFE_CONFIG = GscopeMfeTools.getMfeConfig();
const APP_ENV = MFE_CONFIG.APP_ENV;
const CONFIG_SERVICE = MFE_CONFIG.CONFIG_SERVICE;
const ROUTE_BASED_ROLES_SET = {};
const featuresPromise = IS_TEST_ENV
    ? Promise.resolve({})
    : axios
          .get('/api/gateway/getCCMConfig/features', {
              headers: {
                  loggedinuserid: 'app',
                  currentmarket: 'us',
              },
          })
          .then(({ data }) => {
              return Object.assign(
                  {},
                  ...Object.entries(data).map(([market, fStr]) => ({
                      [market]: JSON.parse(fStr),
                  })),
              );
          });
const currMarket = cookies.get('currentMarket');
let pathsPromise = Promise.resolve([]);
if (currMarket) {
    pathsPromise = IS_TEST_ENV
        ? pathsPromise
        : axios
              .get(`${CONFIG_SERVICE}/paths`, {
                  params: {
                      environment: APP_ENV,
                      market: currMarket,
                  },
                  adapter: cache.adapter,
              })
              .then(({ data }) => data);
}
const getPolicies = _.memoize(function getPolicies() {
    try {
        const permissions = JSON.parse(localStorage.getItem('ngStorage-permissionData')).permissions;
        return permissions as string[];
    } catch (error) {
        return null;
    }
});
function parseResponse(data) {
    for (const page in data) {
        for (const pref in data[page]) {
            data[page][pref] = JSON.parse(data[page][pref]);
        }
    }
    return data;
}

function convertListToMap(array, key) {
    return array.reduce(
        (obj, item) => ({
            ...obj,
            [item[key]]: item,
        }),
        {},
    );
}

function convertMapToList(obj) {
    return Object.keys(obj).map((key) => obj[key]);
}
function extractColumnsFromCsv(csv) {
    const arr = csv.split(/\r\n|\n/);
    const headers = arr[0].split(',').map((each) => each.trim().replace(/^["|'](.*)["|']$/, '$1'));
    return headers;
}
function csvToObjArray(csv) {
    const arr = csv.split(/\r\n|\n/);
    const jsonObj = [];
    const headers = arr[0].split(',');
    arr.forEach((item, index) => {
        if (index > 0) {
            const obj = {};
            item.split(',').forEach((rowData, i) => {
                obj[headers[i]] = rowData;
            });
            jsonObj.push(obj);
        }
    });
    return jsonObj;
}

function objArrayToCSV(arr, header) {
    const headers = header || Object.keys(arr[0]);
    let str = headers.join(',').concat('\r\n');
    arr.forEach((obj) => {
        let line = '';
        let flag = 0;
        headers.forEach((item) => {
            if (line !== '') line += ',';
            else if (line == '' && flag == 1) {
                line += ' ,';
            }
            line += obj[item];
            flag = 1;
        });
        str += `${line}\r\n`;
    });
    return str;
}
/** Get user preference */
async function getUserPreferences(freshData = false) {
    if (!isSellerWfs()) {
        const userId = cookies.get('loggedInUserName');
        let preferences;
        let userPrefenceDataSet;
        if (freshData && userId) {
            try {
                const { data } = await getUserPrefs({ userId });
                userPrefData = data;
                if (userPrefData && userPrefData.status === 'OK') {
                    preferences = userPrefData.payload.pagePreferences
                        ? parseResponse(userPrefData.payload.pagePreferences)
                        : {};
                    localStorage.setItem(`ngStorage-preferences_${userId}`, JSON.stringify(preferences));
                    userPrefenceDataSet = JSON.parse(localStorage.getItem(`ngStorage-preferences_${userId}`));
                }
            } catch (error) {
                console.error('Error in get userPreference ::', error);
                // handle pref api failure to set buckets in app
                return {};
            }
        } else {
            userPrefenceDataSet = localStorage.getItem(`ngStorage-preferences_${userId}`)
                ? JSON.parse(localStorage.getItem(`ngStorage-preferences_${userId}`))
                : null;
        }
        return userPrefenceDataSet;
    }
}

/** Set User Preference
 *  payload structure looks like
 *  payload = {
 *    'pageName' : 'oresolution',
 *    'key' : 'orCols',
 *    'value' : {"holdNo":'', "poNo": '', "customerName": '' }
 *  }
 */
async function setUserPreference({ pageName, key, value }) {
    if (!isSellerWfs()) {
        const userId = cookies.get('loggedInUserName');
        const prefFilter = {
            userId,
            page: pageName,
            preferenceName: key,
            preferenceValue: JSON.stringify(value),
        };
        try {
            const { data } = await manageUserPref(JSON.stringify(prefFilter));
            if (data && data.status === 'OK') {
                const pagePreference = parseResponse(data.payload.pagePreferences);
                localStorage.setItem(`ngStorage-preferences_${userId}`, JSON.stringify(pagePreference));
            }
        } catch (error) {
            console.error('Error in set userPreference ::', error);
        }
    }
}

const setUserMetaData = (data) => {
    let userMetaData;
    if (data.regType) {
        userMetaData = {
            userType: 'External User',
            emailId: data.emailId,
            firstName: data.firstName,
            lastName: data.lastName,
            displayName: `${data.firstName} ${data.lastName}`,
            defaultPassword: data.defaultPassword,
            lastLoggedInDate: data.lastLoggedInDate,
            active: data.active,
            manager: data.manager,
            question: data.question,
            regType: data.regType,
            regTypePayload: data.regTypePayload,
            iamToken: data.iamToken,
            authToken: cookies.get('authToken'),
            authHeader: cookies.get('authHeader'),
            loggedInDomain: cookies.get('loggedInDomain'),
        };
    } else if (cookies.get('auth-src') === 'wire') {
        userMetaData = {
            userType: 'Store User',
            'auth-src': cookies.get('auth-src'),
            authHeader: cookies.get('authToken'),
            authToken: cookies.get('authToken'),
            displayName: cookies.get('displayName'),
            loggedInDomain: cookies.get('loggedInDomain'),
            loggedInUserName: cookies.get('loggedInUserName'),
            market: cookies.get('market'),
            storeNo: cookies.get('store-no'),
            'wire-id': cookies.get('wire-id'),
            'wm-SystemJobcodes': cookies.get('wm-SystemJobcodes'),
            'wm-TypeEmployeeType': cookies.get('wm-TypeEmployeeType'),
        };
    } else {
        userMetaData = {
            userType: 'Internal User',
            emailId: data.emailId,
            authHeader: data.authHeader,
            authToken: data.authToken,
            displayName: data.displayName,
            loggedInDomain: cookies.get('loggedInDomain'),
            loggedInUserName: cookies.get('loggedInUserName'),
        };
    }
    if (userMetaData && Object.keys(userMetaData).length) {
        localStorage.setItem('ngStorage-userMetaData', JSON.stringify(userMetaData));
    }
};

const generateRandomKey = () => Math.random();

const getRoutesFromFeatures = async (market) => {
    const featureJSON = await featuresPromise;
    const feature = featureJSON[market];
    return extractRoutesfromFeature(feature);
};

const extractRoutesfromFeature = (feature, featureRoutes = []) => {
    if (!feature) {
        return featureRoutes;
    }

    for (const key in feature) {
        if (feature[key].route) {
            if (feature[key].route.includes('?')) {
                const staticRoute = feature[key].route.split('?');
                featureRoutes.push(staticRoute[0]);
            }
            featureRoutes.push(feature[key].route);
        }

        if (_.isObject(feature[key].pages)) {
            extractRoutesfromFeature(feature[key].pages, featureRoutes);
        }
    }

    return featureRoutes;
};
async function getMFERoutesRoles(policies, currentMarket) {
    const paths = await pathsPromise;
    const policyPathMap = paths.reduce((acc, { policyName, path }) => {
        if (policyName && path) {
            acc[path] = policyName;
        }
        return acc;
    }, {});
    const policyRolesMap = policies.reduce((acc, policy) => {
        const POLICY_REGEX = new RegExp(`^${currentMarket}\.([^.]+)\.([^:]+):(.*)`);
        if (POLICY_REGEX.test(policy)) {
            const [, bucket, moduleKey, role] = POLICY_REGEX.exec(policy);
            for (const [path, policy] of Object.entries(policyPathMap)) {
                if (policy === `${bucket}.${moduleKey}`) {
                    acc[path] = acc[path] || [];
                    acc[path].push(role);
                }
            }
        }
        return acc;
    }, {});
    return policyRolesMap;
}

const generateRouteMapFromPolicies = async (policies) => {
    const featureJSON = await featuresPromise;
    const routeBasedRole = {};
    policies.forEach((policy) => {
        const splitArr = policy.split(':');
        const role = splitArr[1];
        const policyName = splitArr[0].replace(/-/g, '.').split('.');
        const actualMarket = isInternalSite() ? policyName[0] : `${policyName[0]}_ext`;
        const len = policyName.length;
        if (actualMarket in featureJSON) {
            if (!routeBasedRole[policyName[0]]) {
                routeBasedRole[policyName[0]] = {};
            }
            if (policyName[1] in featureJSON[actualMarket]) {
                if (len === 3) {
                    if (
                        featureJSON[actualMarket][policyName[1]].pages &&
                        Object.keys(featureJSON[actualMarket][policyName[1]].pages).includes(policyName[2])
                    ) {
                        if (
                            !routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].route
                            ]
                        ) {
                            routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].route
                            ] = [role];
                        } else {
                            routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].route
                            ].push(role);
                        }
                    }
                } else if (featureJSON[actualMarket][policyName[1]].pages[policyName[2]]) {
                    if (
                        featureJSON[actualMarket][policyName[1]].pages[policyName[2]].pages &&
                        Object.keys(featureJSON[actualMarket][policyName[1]].pages[policyName[2]].pages).includes(
                            policyName[3],
                        )
                    ) {
                        if (
                            !routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].pages[policyName[3]].route
                            ]
                        ) {
                            routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].pages[policyName[3]].route
                            ] = [role];
                        } else {
                            routeBasedRole[policyName[0]][
                                featureJSON[actualMarket][policyName[1]].pages[policyName[2]].pages[policyName[3]].route
                            ].push(role);
                        }
                    }
                }
            }
        }
    });
    return routeBasedRole;
};

const getRouteBasedRole = () => {
    const routeBasedRoles = JSON.parse(localStorage.getItem('routeBasedRoles'));
    const market = cookies.get('currentMarket');
    const route = window.location.pathname;
    return _.get(routeBasedRoles, [market, route], null);
};

export async function setMFERouteBasedRolesForMarket(market = cookies.get('currentMarket')) {
    if (ROUTE_BASED_ROLES_SET[market]) {
        return;
    }
    const policies = getPolicies();
    const routeBasedRoles = JSON.parse(localStorage.getItem('routeBasedRoles'));
    const route = window.location.pathname;
    const roles = _.get(routeBasedRoles, [market, route], null);
    if (!roles && routeBasedRoles && policies) {
        const mfeRouteBasedRoles = await getMFERoutesRoles(policies, market);
        if (!_.isEmpty(mfeRouteBasedRoles)) {
            routeBasedRoles[market] = { ...(routeBasedRoles[market] || {}), ...mfeRouteBasedRoles };
            localStorage.setItem('routeBasedRoles', JSON.stringify(routeBasedRoles));
            ROUTE_BASED_ROLES_SET[market] = true;
        }
    }
}

const setAppPreference = (displayName, route, keyName = 'favApp') => {
    if (keyName === 'favApp' || keyName === 'mostUsedApp') {
        const userId = cookies.get('loggedInUserName');
        const userPreference = JSON.parse(localStorage.getItem(`ngStorage-preferences_${userId}`));
        const appPref =
            userPreference && userPreference.appPreferences && userPreference.appPreferences[keyName]
                ? userPreference.appPreferences[keyName]
                : {};

        appPref[route] =
            keyName === 'favApp' ? displayName : { displayName, count: appPref[route] ? appPref[route].count + 1 : 1 };
        const reqPayload = {
            pageName: 'appPreferences',
            key: keyName,
            value: appPref,
        };
        return setUserPreference(reqPayload);
    }
    return null;
};

/**
 * @name formatNumber
 * @param  num
 * @desc Formats a given number and adds comma on hundreth places
 */
const formatNumber = (num) =>
    num === 'N/A' || !num
        ? num
        : Math.floor(num)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * @name isSellerWfs
 * @param  none
 * @desc checks if seller center
 */
const isSellerWfs = () => {
    if (window.location.origin.indexOf('seller') !== -1 && window.location.pathname.indexOf('wfsLite') !== -1) {
        return true;
    }
    return false;
};

/**
 * @name unFormatNumber
 * @param  num
 * @desc unFormats a given string and removes comma
 */
const unFormatNumber = (num) => (!num || num === 'N/A' || num === '--' ? num : num.toString().replace(',', ''));

/**
 * @name redirectToSeller
 * @param  none
 * @desc redirects to origin
 */
const redirectToSeller = async () => {
    try {
        const { data } = await logoutWfsSeller();
    } catch (e) {
        console.log(e);
    } finally {
        cookies.remove('JSESSIONID', { path: '/' });
        cookies.remove('_ssoauth', { path: '/' });
        window.open(window.location.origin, '_self', 'noreferrer');
    }
};

const getSpecificPermission = function (pageName) {
    const pagePermission = [];
    if (pageName) {
        const permissionData = JSON.parse(localStorage.getItem('permissionData'));
        if (permissionData) {
            const { permissions } = permissionData;
            const lookup = pageName;
            for (let i = 0; i < permissions.length; i++) {
                if (permissions[i].includes(lookup)) {
                    pagePermission.push(permissions[i]);
                }
            }
        }
    }
    return pagePermission;
};

const parseExternalConfig = (config) => {
    const keys = Object.keys(config);
    let externalObject = {};
    let titleFound = false;
    const favIcon = document.querySelector("link[rel='shortcut icon']") || {};
    if (keys.length) {
        for (let i = 0; i < keys.length; i++) {
            if (window.location.hostname.indexOf(keys[i]) > -1) {
                externalObject = config[keys[i]];
                externalObject.urlKey = keys[i];
                window.document.title = externalObject.appInfo.title; // Dynamic setting of window title
                // TODO: fix requires
                // favIcon.href = require(`../assets/images/${externalObject.appInfo.favicon}`); // Dynamic setting of fav icon
                titleFound = true;
                break;
            }
        }
    }
    if (!titleFound) {
        // TODO: fix requires
        // favIcon.href = require('../assets/images/Logo.png');
        externalObject = config.default;
        externalObject.urlKey = 'defaultURL';
    }
    return externalObject;
};

const isInternalSite = () => {
    const internalUrls = ['localhost', 'walmartlabs'];
    for (let i = 0; i < internalUrls.length; i++) {
        if (window.location.hostname.indexOf(internalUrls[i]) > -1) {
            return true;
        }
    }
    return false;
};

/**
 * @name debounce
 * @desc Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 * @param {function} func
 * @param {Integer} wait
 */

const debounce = (func, wait) => {
    let timeout;

    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
function getBucketInfo(bucketId, featureJSON): string {
    if (!bucketId) {
        return null;
    }
    const marketConfig = getMarketFeatures(featureJSON);
    const bucketPath = bucketId.split('.').join('.pages.');
    const bucket = _.get(marketConfig, bucketPath);
    if (!bucket) {
        return null;
    }
    return _.pick(bucket, ['name', 'icon', 'route', 'iconv2', 'followSequence', 'contextualLSP']);
}
async function getMfeChangeLog() {
    const { data: changeLog } = await axios.get(`${CONFIG_SERVICE}/module/deployed-versions?environment=${APP_ENV}`, {
        adapter: cache.adapter,
        params: {
            environment: APP_ENV,
        },
    });
    return changeLog;
}
function buildAppTrees(appsWithBucketsInfo) {
    Object.values(appsWithBucketsInfo).forEach((a) => {
        const parent = appsWithBucketsInfo[a.parent];
        if (!parent) {
            return;
        }
        parent.childPages = parent.childPages || {};

        if (a.hidden) {
            parent.childPages[a.pageName] = a;
        } else {
            parent.pages = parent.pages || {};
            parent.pages[a.pageName] = a;
        }
    });
    return Object.values(appsWithBucketsInfo).filter((a) => !a.parent);
}
function getMarketFeatures(featureJSON) {
    return featureJSON[cookies.get('currentMarket')];
}
function createNestedBucket(bucketId: string, featureJSON, parentBucketIdPaths = []) {
    const [currentBucketId, ...restBucketIdPaths] = bucketId.split('.');
    const bucketInfo = getBucketInfo([...parentBucketIdPaths, currentBucketId].join('.'), featureJSON);
    const res = {
        [currentBucketId]: {
            pages: {},
            name: bucketInfo?.name || MFE_TEMP_BUCKET_NAME,
            ..._.pick(bucketInfo, ['icon', 'route', 'iconv2', 'followSequence', 'contextualLSP']),
            navKey: currentBucketId,
        },
    };
    if (restBucketIdPaths.length) {
        res[currentBucketId].pages = createNestedBucket(restBucketIdPaths.join('.'), featureJSON, [
            ...parentBucketIdPaths,
            currentBucketId,
        ]);
    }
    return res;
}
function makePolicyNamesUnique(applications) {
    const policyNameMap = {};
    const res = [];
    applications.forEach((a) => {
        if (a.isPOC || a.isUnrestricted) {
            res.push(a);
            return;
        }
        if (policyNameMap[a.policyName]) {
            res.push({ ...a, policyName: `${a.policyName}#${policyNameMap[a.policyName]}` });
            policyNameMap[a.policyName]++;
            return;
        }
        res.push({ ...a, policyName: `${a.policyName}#0` });
        policyNameMap[a.policyName] = 1;
    });
    return res;
}
async function getMfeApps() {
    const market = cookies.get('currentMarket');
    const _applications = await pathsPromise;

    const applications = makePolicyNamesUnique(
        _applications.filter((a) => hasPolicy(a.policyName, a.isPOC, a.isUnrestricted)),
    );
    const featureJSON = await featuresPromise;
    const paths = applications.map((a) => a.path);
    const appsWithBucketsInfo = applications.reduce((acc, cv) => {
        let pageName;
        try {
            if (cv.policyName) pageName = cv.policyName.split('.').at(-1).split(':')[0];
            else pageName = cv.appName.replace(APPNAME_REG_PATTERN, '');
        } catch (error) {
            pageName = cv.appName.replace(APPNAME_REG_PATTERN, '');
        }

        acc[cv.path] = {
            name: cv.appName,
            icon: cv.icon,
            route: cv.path,
            bucket: cv.bucket,
            pageName,
            parent: cv.parent,
            navKey: cv.appName,
            hidden: cv.hidden,
        };
        if (cv.sNo) acc[cv.path].sNo = cv.sNo;

        return acc;
    }, {});
    const appTrees = buildAppTrees(appsWithBucketsInfo);
    const buckets = appTrees.reduce((acc, cv) => {
        if (!cv.bucket) {
            return acc;
        }
        const parentBucket = createNestedBucket(cv.bucket, featureJSON);
        const buckedIdPaths = cv.bucket.split('.');
        const [parentBucketId] = buckedIdPaths;
        const currentBucketPath = buckedIdPaths.join('.pages.');
        const currentBucket = _.get(parentBucket, currentBucketPath);
        currentBucket.pages[cv.pageName] = {
            ..._.pick(parentBucket[parentBucketId], 'contextualLSP'),
            ..._.pick(cv, ['name', 'icon', 'iconv2', 'pages', 'route', 'contextualLSP', 'navKey', 'sNo', 'childPages']),
        };

        const currentPage = _.get(currentBucket, ['pages', cv.pageName]);

        if (_.has(currentPage, 'pages') && _.has(currentPage, 'contextualLSP')) {
            currentPage.pages = Object.entries(_.get(currentPage, 'pages')).reduce(
                (acc, [key, val]) => Object.assign(acc, { [key]: { ...val, contextualLSP: true } }),
                {},
            );
        }

        return merge.all([acc, parentBucket]);
    }, {});
    return {
        buckets,
        paths,
        applications,
    };
}

function hasPolicy(
    targetPolicyName: string,
    isPOC = false,
    isUnrestricted = false,
    currentMarket = cookies.get('currentMarket'),
): boolean {
    const permissions = getPolicies();
    if (!permissions) {
        return false;
    }
    if (isPOC || isUnrestricted) {
        return true;
    }
    if (_.isUndefined(targetPolicyName) || _.isNull(targetPolicyName)) {
        return false;
    }
    const [trimmedTargetPolicyName] = targetPolicyName.split('#');
    const targetPolicyNameParts = [currentMarket].concat(
        POLICY_NAME_REGEX.test(trimmedTargetPolicyName) ? trimmedTargetPolicyName.split(POLICY_NAME_REGEX) : [],
    );

    return permissions.some((currentPolicyName) => {
        const currentPolicyNameParts = currentPolicyName
            .split(POLICY_NAME_REGEX)
            .slice(0, targetPolicyNameParts.length);
        return _.isEqual(currentPolicyNameParts, targetPolicyNameParts);
    });
}
const fetchPermission = async (domain, userId) => {
    try {
        const response = await axios.get('api/gateway/manage/userdetails', {
            params: { domain: domain, loginid: userId },
            headers: { loggedInUserId: userId },
        });
        if (response?.status == 200 && response?.data?.permissions && response?.data?.markets) {
            const routeBasedRoles = await generateRouteMapFromPolicies(response.data.permissions);
            localStorage.setItem('routeBasedRoles', JSON.stringify(routeBasedRoles));
            return response.data;
        } else {
            throw response;
        }
    } catch (e) {
        throw e;
    }
};
const getModulesFromAbbreviations = (pagesArray, bucketsLookup) => {
    const buckets = {};
    pagesArray.forEach((page) => {
        let pageKeys = [];
        if (page) {
            pageKeys = page.split('.');
            pageKeys.splice(0, 1);
        }

        let bucketCP = bucketsLookup;
        //build a nested object out of the pageKeys
        if (pageKeys) {
            pageKeys.reduce(function (r, a, index) {
                console.log(bucketCP);
                console.log(bucketCP[pageKeys[index]]);
                if (pageKeys[index] != '*' && bucketCP[pageKeys[index]]) {
                    r[a] = r[a] || { pages: {}, name: bucketCP[pageKeys[index]].name };
                    if (index == pageKeys.length - 1 || (index != pageKeys.length - 1 && pageKeys[index + 1] == '*')) {
                        r[a].pinned = true;
                        if (
                            !bucketCP[pageKeys[index]]['pages'] &&
                            ((r[a].pages && Object.keys(r[a].pages).length == 0) || !r[a].pages)
                        )
                            r[a].route = bucketCP[pageKeys[index]].route;
                        r[a].pinPath = page;
                    }
                    bucketCP = bucketCP[pageKeys[index]].pages;
                    return r[a].pages;
                }
            }, buckets);
        }
    });
    return buckets;
};
async function getAllEnvironments() {
    const infra = window.GscopeMfeTools.getInfra();
    return (await axios.get(`${CONFIG_SERVICE}/environment/list?infra=${infra}`)).data;
}
function removeDirectAcessPages(type) {
    return type === 'payload'
        ? removeDirectAcessPagesPayload
        : type === 'localStorage'
        ? removeDirectAcessPagesLocalStorage
        : removeDirectAcessPagesCookies;
    function removeDirectAcessPagesPayload(jsonData) {
        const { userId, page, preferenceName, preferenceValue } = jsonData;
        try {
            const _preferenceValue = JSON.parse(JSON.stringify(preferenceValue));
            if (globalVars.removeDirectAcessPagesList.preferenceNames.includes(preferenceName)) {
                Object.keys(_preferenceValue).forEach((region) => {
                    globalVars.removeDirectAcessPagesList.pages.forEach((pageName) => {
                        const removeIndex = _preferenceValue[region].findIndex(
                            (page) =>
                                page === pageName ||
                                page === region + '.' + pageName ||
                                page.name === pageName ||
                                page.name === region + '.' + pageName,
                        );
                        if (removeIndex > -1) {
                            _preferenceValue[region].splice(removeIndex, 1);
                        }
                    });
                });
            }
            return {
                userId,
                page,
                preferenceName,
                preferenceValue: JSON.stringify(_preferenceValue),
            };
        } catch (error) {
            return {
                userId,
                page,
                preferenceName,
                preferenceValue: JSON.stringify(preferenceValue),
            };
        }
    }
    function removeDirectAcessPagesLocalStorage(jsonData) {
        const preferences = parseResponse(jsonData);
        try {
            const _preferences = JSON.parse(JSON.stringify(preferences));
            Object.keys(_preferences.appHome).forEach((preferenceName) => {
                Object.keys(_preferences.appHome[preferenceName]).forEach((region) => {
                    globalVars.removeDirectAcessPagesList.pages.forEach((pageName) => {
                        const removeIndex = _preferences.appHome[preferenceName][region].findIndex(
                            (page) =>
                                page === pageName ||
                                page === region + '.' + pageName ||
                                page.name === pageName ||
                                page.name === region + '.' + pageName,
                        );
                        if (removeIndex > -1) {
                            _preferences.appHome[preferenceName][region].splice(removeIndex, 1);
                        }
                    });
                });
            });
            return _preferences;
        } catch (error) {
            return preferences;
        }
    }
    function removeDirectAcessPagesCookies(url) {
        try {
            const [urlPathName, urlParams] = url.split('?');
            const urlText = urlPathName
                .split('/')
                .filter((el) => el !== '')
                .join('')
                .toLowerCase();
            const pages = globalVars.removeDirectAcessPagesList.pages.map((el) =>
                el
                    .split('.')
                    .reduce((acc, curr, idx) => {
                        acc = acc.concat(curr);
                        if (idx === 2) {
                            acc = acc.filter((_, idx) => idx > 0);
                        }
                        return acc;
                    }, [])
                    .join('')
                    .toLowerCase(),
            );
            const status = pages.find((el) => el === urlText) ? true : false;
            if (status) {
                if (!urlParams) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (err) {
            return false;
        }
    }
}
function getAllPermittedMfeRoutesInMarket(market) {
    const moduleListStr = sessionStorage.getItem(SESSION_STORAGE_GSCOPE_MODULE_LIST_KEY);
    if (!moduleListStr) {
        return [];
    }
    let moduleList;
    try {
        moduleList = JSON.parse(moduleListStr);
    } catch (error) {
        return [];
    }
    return _.flatten(
        moduleList.map((m) =>
            m.activeWhen.filter((a) => hasPolicy(a.policyName, a.isPOC, a.isUnrestricted, market)).map((a) => a.path),
        ),
    );
}
export {
    convertListToMap,
    parseResponse,
    convertMapToList,
    getUserPreferences,
    setUserPreference,
    cookies,
    setUserMetaData,
    getUserMetaData,
    csvToObjArray,
    objArrayToCSV,
    generateRandomKey,
    setAppPreference,
    formatNumber,
    getRouteBasedRole,
    generateRouteMapFromPolicies,
    isSellerWfs,
    redirectToSeller,
    unFormatNumber,
    parseExternalConfig,
    getSpecificPermission,
    isInternalSite,
    clearStorage,
    debounce,
    getMfeApps,
    getPolicies,
    hasPolicy,
    createAxiosInstance,
    getMfeChangeLog,
    extractColumnsFromCsv,
    fetchPermission,
    getModulesFromAbbreviations,
    getAllEnvironments,
    removeDirectAcessPages,
    getRoutesFromFeatures,
    getAllPermittedMfeRoutesInMarket,
    featuresPromise,
    pathsPromise,
    axiosLib,
};
